import React from 'react';
import Hero from '../components/home/Hero';
import Marquee from '../components/Marquee';
import SessionCountdown from '../components/home/SessionCountdown';
import Approach from '../components/home/Approach';
import Trust from '../components/home/Trust';
import PoolPromise from '../components/home/PoolPromise';
import ProgramsPreview from '../components/home/ProgramsPreview';
import MeetCoachAbrie from '../components/home/MeetCoachAbrie';
import Testimonials from '../components/home/Testimonials';
import HopeFloatsSpotlight from '../components/home/HopeFloatsSpotlight';
import InstagramFeed from '../components/home/InstagramFeed';

export default function Home() {
  return (
    <main>
      <SessionCountdown variant="compact" />
      <Hero />
      <Marquee />
      <SessionCountdown />
      <HopeFloatsSpotlight />
      <Approach />
      <PoolPromise />
      <Trust />
      <MeetCoachAbrie />
      <ProgramsPreview />
      <Testimonials />
      <InstagramFeed />
    </main>
  );
}
